import React, {Component, Fragment} from 'react';
import MemberEligibility from './MemberEligibility/MemberEligibiilty';
import MemberAccount from './MemberAccount/MemberAccount';
import QuickView from './QuickView/QuickView';
import DisplayBox from '../../hoc/DisplayBox/DisplayBox';
// import Message from '../../components/Message/Message';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from '../../UI/Spinner/Spinner';
import * as actions from "../../store/actions";
import { decodeBase64, getIsHSID, isBasicMemberAccount, isPartialRegistration } from '../../shared/utility';
import { LS_OTP_VERIFIED, LS_DISABLE_IDENTITY_ATTEST_FAIL, SESSION_READONLYUSER, SESSION_SUPERUSER, QUICK_VIEW_MODES, HSID_HEADLESS, HSID_BASE, HSID_PARTIAL_REGISTRATION,HSID_DELETED, HSID_NULL, SDK_PORTAL_LIST, SESSION_TIER1USER, SESSION_SUPERVISORUSER, LS_OTP_VERIFIED_NUMBER, SESSION_BASELINEAGENT } from '../../shared/Constants';
import MemberEligibilityReadOnly from './MemberEligibility/MemberEligibilityReadOnly';
import AccountSecurity from './EnableDisable/AccountSecurity';
import Passkey from './Passkey/Passkey';
import IdentityConfirmation from './IdentityConfirmation/IdentityConfirmation';

export class Member extends Component {
    state = {
        memberAccountExpanded: true,
        memberEligibilityExpanded: false,
        quickViewExpanded: true,
        quickViewDisable: false,
        enableDisableExpanded: false,
        showModal: false,
        showDeleteEligModal: false,
        showRebuildMyuhcModal: false,
        memberPortalData: null,
        user:null,
        mbrPortalInfo: null,
        isOTPVerified: false,
        sdkPortalList: null
    }

    componentDidMount() {        
        let uuid = this.props.match.params.uuid;
        let idType = this.props.match.params.idType;
        if (uuid) {
            // If the uuid in the url exists and is valid then only it will stay on the page otherwise it will redirect to the search page.
            let decodedUUID = decodeBase64(uuid)
            !decodedUUID && this.props.history.push("/")
            decodedUUID && this.props.selectMember({uuid: decodedUUID}, idType);
        }
        if (localStorage.getItem(LS_OTP_VERIFIED) !== uuid) {
            //We are considering as verified because this ID is still active in the local storage
            localStorage.removeItem(LS_OTP_VERIFIED)
            localStorage.removeItem(LS_OTP_VERIFIED_NUMBER)
        }
        if(localStorage.getItem(LS_DISABLE_IDENTITY_ATTEST_FAIL) !== uuid) {
            localStorage.removeItem(LS_DISABLE_IDENTITY_ATTEST_FAIL)
        }
        if (!this.props.sdkPortalList) {
            this.props.fetchPortalConfig();
        }
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        this.props.setDeleteEligMsgToNull();
        this.props.setMemberEligMsgToNull();
    }

    accountExpandHandler = () => {
        // console.log("[Member] account expand handler", this.state.memberAccountExpanded);
        this.setState({memberAccountExpanded: !this.state.memberAccountExpanded});
    }

    createIncidentHandler = () => {
        this.props.resetIncidentMembersList([{member:[this.props.memberData], 
            essoData: this.props.memberData.essoData,
            idType: this.props.memberData.idType,
            priImpactedFlag: this.props.memberData.priImpactedFlag, }]);
        this.props.history.push("/serviceNow")
    }

    enableDisableExpandHandler = () => {
        this.setState({enableDisableExpanded: !this.state.enableDisableExpanded})
    }

    quickViewExpandHandler = () => {
        this.setState({quickViewExpanded: !this.state.quickViewExpanded});
    }

    toggleQuickView = () => {
        this.setState({quickViewDisable: !this.state.quickViewDisable});
    }

    viewModalHandler = (data) => {
        const memberPortalData = data? data: null;
        this.setState({showModal: !this.state.showModal, memberPortalData: memberPortalData});
    }

    deleteModalHandler = (data) => {
        const memberPortalData = data? data: null;
        this.setState({showDeleteEligModal: !this.state.showDeleteEligModal, memberPortalData: memberPortalData});
    }

    viewRebuildModalHandler = (data) => {
        const memberPortalData = data? data: null;
        this.setState({showRebuildMyuhcModal: !this.state.showRebuildMyuhcModal, memberPortalData: memberPortalData});
    }

    createEligibilityInfo = (mbrPortalInfo) =>{      
        let identifier = mbrPortalInfo.portalEligibilityResponse && mbrPortalInfo.portalEligibilityResponse.eligibilityInfo !== "NA" 
        ? mbrPortalInfo.portalEligibilityResponse.eligibilityInfo[0].identifiers:undefined;
        return {
            ...identifier,
            "firstName": mbrPortalInfo.portalFirstNm,
            "lastName" : mbrPortalInfo.portalLastNm,
            "dob" : mbrPortalInfo.portalDob,
            "subscriberId": mbrPortalInfo.portalSubscriberId,
            "memberId": mbrPortalInfo.portalSpecificMemberId,
            "policyNumber": mbrPortalInfo.portalPolicyNbr,
            "zipCode": mbrPortalInfo.portalZip
        }
    }

    deleteEligibilityHandler = (mbrPortalInfo) => {
        let eligibilityInfoObject = this.createEligibilityInfo(mbrPortalInfo);
        
        let formData = {
            healthsafeid: this.props.memberData.healthSafeId,
            portalShortNmList: mbrPortalInfo.portalShortNm,
            datatobeUpdated: "Eligibility",
            attributetobeUpdated: "MemberStatus",
            policyNum: mbrPortalInfo.portalPolicyNbr === '-' ? '' : mbrPortalInfo.portalPolicyNbr,
            provisionMemberId: mbrPortalInfo.memberPortalId.toString(),
            status: "Purged",
            userName: this.props.memberData.essoData?.userName,
            eligibilityInfo: eligibilityInfoObject
        }
        
        this.props.deleteEligibility(formData, mbrPortalInfo, this.props.portals);
        this.deleteModalHandler();
    }

    showAddEligibility = () => {
        //console.log("[Member] showAddEligibility - Member Portal data: " ,this.props);
        this.props.setDeleteEligMsgToNull();
        this.props.setMemberEligMsgToNull();
        let uuid = this.props.match.params.uuid ? this.props.match.params.uuid : "";
        this.props.history.push({
            pathname: `/addEligibility/${uuid}`,
            state: {idType: this.props.location.state.idType}
        });
    }

    modifyEligibilityHandler = (portal) => {
        this.props.setDeleteEligMsgToNull();
        this.props.setMemberEligMsgToNull();
        const selectedPortal = this.props.memberData.memberPortalAttributeList? this.props.memberData.memberPortalAttributeList.filter(x => x.portalShortNm === portal.portalShortNm && (x.memberPortalId === portal.memberPortalId)):null;
        // console.log("[Member] modifyEligibilityHandler", selectedPortal, portal, this.props.memberData.memberPortalAttributeList);
        this.props.setModifyEligibilityPortal(selectedPortal);
    }

    render() {
        // console.log("[Member] render", this.props);
        // default form, form when member data is not available
        let idType = this.props.location.state.idType, isHSID = getIsHSID(idType);
        let isNullHSID = (idType === HSID_NULL)?true:false;
        let isDeletedNullHSID = (idType === HSID_DELETED && !this.props.memberData?.essoData)?true:false;
        let isHeadlessUser = (idType === HSID_HEADLESS)? true:false;
        let allowHeadlessUser = !isHeadlessUser;
        let allowUser = isNullHSID || isHeadlessUser || isDeletedNullHSID;
        let viewType = idType === HSID_BASE ? QUICK_VIEW_MODES.BASIC_ACCOUNT_VIEW :(this.props.user.userType===SESSION_READONLYUSER ? QUICK_VIEW_MODES.READ_ONLY_VIEW : null);
        let hsid_non_member = HSID_PARTIAL_REGISTRATION;
        //essoData check for Null HSID user to not display MemberAccount
        //enableMemberAccount for Headless user
        let quickView = (this.props.memberData && this.props.memberData.essoData && allowHeadlessUser) || (this.props.memberData && allowUser)?(
            <DisplayBox>
                <QuickView
                    memberData={this.props.memberData}
                    expanded={this.state.quickViewExpanded}
                    expandHandler={this.quickViewExpandHandler}
                    quickViewDisable={this.state.quickViewDisable}
                    toggleQuickView={this.toggleQuickView}
                    isHSID={isHSID}
                    isHeadlessUser={isHeadlessUser}
                    idType={idType}
                    userType={this.props.user.userType}
                    viewType={viewType}
                    isNullHSID={isNullHSID || isDeletedNullHSID}
                />
                </DisplayBox>):null;
        let memberAccount = (this.props.memberData && this.props.memberData.essoData && !this.props.memberData?.essoData?.accountStatus?.accountDeleted && allowHeadlessUser && !isPartialRegistration(idType) && !isNullHSID && idType !== HSID_DELETED) || (isPartialRegistration(idType) 
        && !this.props.memberData?.essoData?.accountStatus?.accountDeleted
        && this.props.user.userType !== SESSION_READONLYUSER) ?(
            <DisplayBox>
                <MemberAccount
                    memberData={this.props.memberData}
                    expanded={this.state.memberAccountExpanded}
                    expandHandler={this.accountExpandHandler}
                    createIncidentHandler={this.createIncidentHandler}
                    userType={this.props.user.userType}
                    user={this.props.user}
                    isHSID={isHSID}
                    idType={idType}
                    isHeadlessUser={isHeadlessUser}
                    isOTPVerified={ this.props.user.userType===SESSION_SUPERUSER ||
                        (this.props.user.userType===SESSION_SUPERVISORUSER && isPartialRegistration(idType))
                        || this.props.user.userType===SESSION_READONLYUSER || localStorage.getItem(LS_OTP_VERIFIED) === this.props.match.params.uuid}
                />
            </DisplayBox>): null;
        let memberEligibility = (isHSID || allowUser) && !isPartialRegistration(idType) && idType !== HSID_DELETED ? ((this.props.user.userType === SESSION_READONLYUSER) && (!isBasicMemberAccount(idType)) ? (<DisplayBox>
                <MemberEligibilityReadOnly
                    {...this.props}
                    showModal={this.state.showModal}
                    showRebuildMyuhcModal={this.state.showRebuildMyuhcModal}
                    modalHandler={this.viewModalHandler}
                    viewRebuildModalHandler={this.viewRebuildModalHandler}
                    memberPortalData={this.state.memberPortalData}
                    showAddEligibility={this.showAddEligibility}
                    modifyEligibility={this.modifyEligibilityHandler}
                    isNullHSID={isNullHSID}
                    isHeadlessUser={isHeadlessUser}
                    idType={idType}
                    sdkPortalList={JSON.parse(localStorage.getItem(SDK_PORTAL_LIST)) ?  JSON.parse(localStorage.getItem(SDK_PORTAL_LIST)) : this.props.sdkPortalList}
                />
            </DisplayBox>):
            (!isBasicMemberAccount(idType) && !isPartialRegistration(idType)
            ? <DisplayBox>
                <MemberEligibility
                    {...this.props}
                    showModal={this.state.showModal}
                    showDeleteEligModal={this.state.showDeleteEligModal}
                    showRebuildMyuhcModal={this.state.showRebuildMyuhcModal}
                    modalHandler={this.viewModalHandler}
                    deleteModalHandler={this.deleteModalHandler}
                    viewRebuildModalHandler={this.viewRebuildModalHandler}
                    memberPortalData={this.state.memberPortalData}
                    showAddEligibility={this.showAddEligibility}
                    modifyEligibility={this.modifyEligibilityHandler}
                    deleteEligibility = {this.deleteEligibilityHandler}
                    isNullHSID={isNullHSID}
                    isHeadlessUser={isHeadlessUser}
                    idType={idType}
                    isOTPVerified={ this.props.user.userType===SESSION_SUPERUSER || this.props.user.userType===SESSION_SUPERVISORUSER
                         || this.props.user.userType===SESSION_READONLYUSER || localStorage.getItem(LS_OTP_VERIFIED) === this.props.match.params.uuid}
                    sdkPortalList={JSON.parse(localStorage.getItem(SDK_PORTAL_LIST)) ?  JSON.parse(localStorage.getItem(SDK_PORTAL_LIST)) : this.props.sdkPortalList}
                />
            </DisplayBox>:null)): null;

        const enableDisable = this.props.memberData && this.props.memberData.essoData && !this.props.memberData?.essoData?.accountStatus?.accountDeleted && allowHeadlessUser && !isNullHSID && 
        [SESSION_SUPERUSER, SESSION_TIER1USER, SESSION_SUPERVISORUSER].includes(this.props.user.userType) &&
        idType !== HSID_DELETED ?(
            <DisplayBox>
                <AccountSecurity
                    memberData={this.props.memberData}
                    expanded={this.state.enableDisableExpanded}
                    expandHandler={this.enableDisableExpandHandler}
                    userType={this.props.user.userType}
                    idType={idType}
                />
            </DisplayBox>): null; 
            
        const renderIdentityConfirmation = () => {
            return (![SESSION_BASELINEAGENT, SESSION_READONLYUSER].includes(this.props.user.userType) && 
                ![HSID_BASE, HSID_DELETED].includes(idType) && !this.props.memberData?.essoData?.accountStatus?.accountDeleted &&
                !isNullHSID &&
                <DisplayBox>
                    <IdentityConfirmation />
                </DisplayBox>
            )
        }
            
        const renderPasskey=()=>{
            return(this.props.passkeyList && this.props.passkeyList.length>0 ?
            <DisplayBox>
                <Passkey
                    isOTPVerified={ this.props.user.userType===SESSION_SUPERUSER || this.props.user.userType===SESSION_SUPERVISORUSER
                            || this.props.user.userType===SESSION_READONLYUSER || localStorage.getItem(LS_OTP_VERIFIED) === this.props.match.params.uuid}
                            />
            </DisplayBox>
            : null)
        }    

        let lineGap = (memberEligibility || memberAccount || renderPasskey() || renderIdentityConfirmation())? <br/>:null;
        let form = <Spinner/>;
        if(!this.props.loading && this.props.memberData) {
            if (this.props.memberData.essoData && Object.keys(this.props.memberData.essoData).length === 0 || this.props.memberError?.status==="FAILURE") {
                form = (
                    <DisplayBox>
                        <Redirect to="/search"></Redirect>
                    </DisplayBox>
                );
            } else {
                form = (
                    <Fragment>
                        {quickView}
                        {lineGap}
                        {renderIdentityConfirmation()}
                        {lineGap}
                        {renderPasskey()}
                        {lineGap}
                        {memberEligibility}
                        {lineGap}
                        {memberAccount}
                        {lineGap}
                        {enableDisable}
                    </Fragment>
                );
            }
        } 
        if(this.props.memberError?.status==="FAILURE"){
            form = (
                <DisplayBox>
                    <Redirect to="/search"></Redirect>
                </DisplayBox>
            );
        }
        return form ;
    }
}

export const mapStateToProps = state => {
    return {
        memberData: state.member.member,
        memberError: state.member.error,
        loading: state.member.loading,
        user: state.usr.user,
        sdkPortalList: state.member.sdkPortalList,
        portals: state.personalInfo.portals,
        smsOtpMessage: state.member.smsOtpMessage, //this will ensure the refresh when sms/email otp updation happens
        passkeyList: state.member.passkeyList
    }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        selectMember: (selectedMember, idType) => dispatch(actions.selectMember(selectedMember, idType)),
        setModifyEligibilityPortal: (portalInfo) => dispatch(actions.setModifyEligibilityPortal(portalInfo, ownProps.history)),
        deleteEligibility: (memberPortalData, mbrPortalInfo, portals) => dispatch(actions.deleteEligibility(memberPortalData, mbrPortalInfo, portals, ownProps.history)),
        setDeleteEligMsgToNull: () => dispatch(actions.setDeleteEligMsgToNull()),
        setMemberEligMsgToNull: () => dispatch(actions.setMemberEligMsgToNull()),
        fetchPortalConfig: () => dispatch(actions.fetchPortalConfig()),
        resetIncidentMembersList: (data) => dispatch(actions.resetIncidentMembersList(data)),
        fetchPasskeyList: (uuid) => dispatch(actions.fetchPasskeyList(uuid)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Member);